<template>
	<div class="appearance-container">
		<BackToSettings />
		<div class="appearance-content">
			<div class="appearance-title" v-t="'settings_option_appearance'" />
			<div
				class="appearance-subtitle"
				v-t="'settings_appearance_theme_label'"
			/>
			<RadioGroup :options="schemeOptions" v-model="colorScheme" localize />
			<div
				class="appearance-subtitle"
				v-t="'settings_appearance_contrast_label'"
			/>
			<RadioGroup :options="contrastOptions" v-model="colorContrast" localize />
		</div>
	</div>
</template>

<script setup>
import { ref, watch } from 'vue'
import BackToSettings from './BackToSettings'
import { RadioGroup } from '@/components/common'
import {
	getSavedColorSchemePreference,
	getSavedColorContrastPreference,
	setColorContrastPreference,
	setColorSchemePreference,
	switchGlobalColorScheme,
} from '@/helpers/colors'
import { colorSchemes, colorContrasts } from '@/helpers/constants'

const schemePref = getSavedColorSchemePreference() || colorSchemes.SYSTEM
const contrastPref = getSavedColorContrastPreference() || colorContrasts.SYSTEM

const colorScheme = ref(schemePref)
const colorContrast = ref(contrastPref)

const schemeOptions = [
	{
		value: colorSchemes.LIGHT,
		label: 'settings_appearance_light',
	},
	{
		value: colorSchemes.DARK,
		label: 'settings_appearance_dark',
	},
	{
		value: colorSchemes.SYSTEM,
		label: 'settings_appearance_system',
	},
]

const contrastOptions = [
	{
		value: colorContrasts.NORMAL,
		label: 'common_level_normal',
	},
	{
		value: colorContrasts.HIGH,
		label: 'common_level_high',
	},
	{
		value: colorContrasts.SYSTEM,
		label: 'settings_appearance_system',
	},
]

watch(colorContrast, (val) => {
	setColorContrastPreference(val)
	switchGlobalColorScheme(colorScheme.value, val)
})

watch(colorScheme, (val) => {
	setColorSchemePreference(val)
	switchGlobalColorScheme(val, colorContrast.value)
})
</script>

<style lang="scss" scoped>
.appearance-container {
	position: relative;
	width: 100%;
	padding: 80px;
	.appearance-content {
		max-width: 600px;
		margin: 0 auto;
		.appearance-title {
			width: 100%;
			text-align: center;
			font-size: 30px;
			margin-bottom: 32px;
		}
		.appearance-subtitle {
			font-size: 18px;
			margin-bottom: 8px;
		}
		.pronto-radio-group {
			margin-bottom: 32px;
		}
	}
}
</style>
